export const extensionTypes = {
  HTML: '.html',
  MARKDOWN: '.md',
  TEXT: '.txt',
  XML: '.xml',
};

export const mimeTypes = {
  CSV: 'text/csv',
  HTML: 'text/html',
  MARKDOWN: 'text/markdown',
};
